import { executeRequest, Request } from '@jfs/network'
import { getProfileNamesChannelId } from '../components/ApiConfig'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const updateProfileMappingBody = (selectedItems: any[], consumerChannelId: string) => {
  const selectedList: any[] = []
  selectedItems.map((selectedItem: any) => {
    selectedList.push({
      apiId: selectedItem.apiId,
      consumerChannelId: consumerChannelId,
      status: selectedItem.isSelected ? 1 : 2,
    })
  })
  const finalList = selectedList.filter((obj, index) => {
    return index === selectedList.findIndex((o) => obj.apiId === o.apiId)
  })
  console.log('updateProfileMappingBody parsedObjs', finalList)
  return {
    updateApiMappingRequestList: finalList,
  }
}

export const getAppProfileId = (profileName: string) => {
  return getProfileNamesChannelId().filter((profile) => profile.name === profileName)?.[0]?.appProfileId
}

const updateApiStatusByProfileNameBody = (profileName: string, consumerChannelId: string, status: number) => {
  return {
    updateApiMappingRequestList: [
      {
        appProfileId: getAppProfileId(profileName),
        consumerChannelId: consumerChannelId,
        status: status,
      },
    ],
  }
}

const updatApisStatusReq = (data: any[], consumerChannelId: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.updateApiMapping,
    method: 'POST',
    config: sitConfig(tokens),
    body: updateProfileMappingBody(data, consumerChannelId),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

const updatApisStatusByProfileNameReq = (
  profileName: string,
  consumerChannelId: string,
  status: number,
  tokens: any,
) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.updateApiMapping,
    method: 'POST',
    config: sitConfig(tokens),
    body: updateApiStatusByProfileNameBody(profileName, consumerChannelId, status),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { updatApisStatusReq, updatApisStatusByProfileNameReq }
